import React, { Component } from 'react';
import { Container } from 'react-bootstrap';
import * as Cookies from 'es-cookie';
import { withRouter } from 'react-router-dom';
import { isBrowser, isMobile } from 'react-device-detect';

import AsideNavbar from '../components/navbars/AsideNavbar';
import HomeNavbar from '../components/home/HomeNavbar';
import StudentCalendarSection from '../components/Calendar/StudentCalendarSection';

class StudentCalendarPage extends Component {
  menuToggler = () => {
    const toggled = Cookies.get('toggle');
    if (toggled === 'wrapper') {
      Cookies.set('toggle', 'wrapper sidebar-enable');
    } else {
      Cookies.set('toggle', 'wrapper');
    }
    this.forceUpdate();
  };

  render() {
    if (Cookies.get('studenttoken') === undefined) {
      this.props.history.push('/student/login');
      return null;
    }

    return (
      <div className={Cookies.get('toggle')}>
        <div className="header-area">
          <HomeNavbar onClick={() => this.menuToggler()} />
        </div>
        <div className="main-wrapper">
          <AsideNavbar onClick={() => this.menuToggler()} />
          <div className="student-overlay" onClick={() => this.menuToggler()} />
          <div className="content-wrapper pt-0">
            <Container fluid>
              <StudentCalendarSection />
            </Container>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(StudentCalendarPage);
